/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    seasonalDiscountsData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerSeasonalDiscounts = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_SEASONAL_DISCOUNTS_DATA':
            var { data } = action;
            newState.seasonalDiscountsData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerSeasonalDiscounts;